
var teaser = document.querySelectorAll('.teaser__wrap');

Array.prototype.forEach.call(teaser, function (teaseritem) {
	
	if ( teaseritem.querySelector('.teaser__heading a') ) {
		
	  var down,
	      up,
	      link = teaseritem.querySelector('.teaser__heading a'); // let teasercta = teaseritem.querySelector('.teaser__cta');
	  // teaseritem.style.cursor = 'pointer';
	  // teasercta.style.display = 'block';
	
	  teaseritem.onmousedown = function () {
	    return down = +new Date();
	  };
	
	  teaseritem.onmouseup = function (event) {
	    up = +new Date();
	
	    if (up - down < 200) {
	        if(event.button === 0) {
	            link.click();
	        }
	    }
	  };	  
	}
});





$(document).ready(function(){
	
	
	$('.teaser__options .checkbox--cup input').on("click", function(){
		
		var thisContainer = $(this).parents(".teaser");
		var thisPrice = parseInt( $(".teaser__price span", thisContainer).text() );
		
		if ( $(this).is(':checked') ) {
		
			$(".teaser__cta .button strong", thisContainer).text( thisPrice + 2 );
		
		} else {
			
			$(".teaser__cta .button strong", thisContainer).text( thisPrice );
		
		}
		
	});
});
